import styled from "styled-components/macro";
import { colors } from "shared/styles/constants";
import { rgba } from "polished";

export const TravelLegsMapOverlay = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: ${rgba(colors.black, 0.5)};
`;
